import { Component, inject } from '@angular/core';
import { AsahiProductComponent } from '../asahi-product/asahi-product.component';
import { AsahiFooterComponent } from '../asahi-footer/asahi-footer.component';
import { ClevertapService } from '../../../service/clevertap.service';
import { AsahiBannerComponent } from '../asahi-banner/asahi-banner.component';
import { AsahiNavbarComponent } from '../asahi-navbar/asahi-navbar.component';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { AsahiWhytochooseComponent } from '../asahi-whytochoose/asahi-whytochoose.component';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { LeadService } from '../../../service/lead.service';

@Component({
  selector: 'app-asahi-home',
  imports: [AsahiNavbarComponent, CommonModule, RouterModule, AsahiBannerComponent, AsahiWhytochooseComponent, AsahiProductComponent, AsahiFooterComponent],
  templateUrl: './asahi-home.component.html',
  styleUrl: './asahi-home.component.scss'
})
export class AsahiHomeComponent {
  source: string | null = null;
  clevertapService = inject(ClevertapService)
  showLayout = true;
  constructor(private router: Router, private route: ActivatedRoute, private leadservice: LeadService) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = (event as NavigationEnd).urlAfterRedirects;
        this.showLayout = !/^\/(en|vi)\/income-protection-insurance\/(explore|mobile|success-page|mobile-success-page|details|mobile-premium|mobile-premium-form|mobile-premium-details)(\?.*)?$/.test(url);
      });
  }
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.source = params.get('traffic_source');
    });
    const productType = 'income_protection';
    const trafficSource = this.source;
    const currentRoute = this.router.url;
    this.clevertapService.clearStorage();
    if (!currentRoute.includes('explore')) {
      this.clevertapService.trackEvent('visited_product_landing_page', {
        traffic_source: trafficSource,
        product_type: productType
      });
    }
  }
}
